import { Injectable, Type, inject } from '@angular/core';

import { EventModel } from '@frontend/sports/betting-offer/feature/model';
import { LoggerFactory } from '@frontend/sports/common/core/feature/logging';
import { ComponentLoaderService, ComponentProxy } from '@frontend/sports/deferred/feature/component-loader';
import { ModuleLoaderService } from '@frontend/sports/deferred/feature/module-loader';

import { EventDetailsModule } from './event-details.module';

export interface EventSwitcherEventViewBinding {
    event: EventModel;
}

@Injectable({ providedIn: 'root' })
export class EventSwitcherComponentLoaderService extends ComponentLoaderService<EventDetailsModule> {
    moduleName = 'EventDetailsModule';
    componentProxy: ComponentProxy<EventSwitcherEventViewBinding>;

    constructor() {
        const moduleLoader = inject(ModuleLoaderService);
        const loggerFactory = inject(LoggerFactory);

        super(moduleLoader, loggerFactory);
        this.componentProxy = this.getComponentProxy<EventSwitcherEventViewBinding>((module) => module.eventSwitcherComponent);
    }

    getEventSwitcherComponent(): ComponentProxy<EventSwitcherEventViewBinding> {
        return this.componentProxy;
    }

    getModule(): Promise<Type<EventDetailsModule>> {
        return import('./event-details.module').then((m) => m.EventDetailsModule);
    }
}
